var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46094 2.02588H15.0986C15.4282 2.02588 15.6919 1.76953 15.6919 1.43994C15.6919 1.11035 15.4282 0.84668 15.0986 0.84668H1.46094C1.13135 0.84668 0.867676 1.11035 0.867676 1.43994C0.867676 1.76953 1.13135 2.02588 1.46094 2.02588ZM2.99902 5.79785H13.5972C13.9268 5.79785 14.1831 5.5415 14.1831 5.21191C14.1831 4.88232 13.9268 4.61865 13.5972 4.61865H2.99902C2.66943 4.61865 2.41309 4.88232 2.41309 5.21191C2.41309 5.5415 2.66943 5.79785 2.99902 5.79785ZM4.50049 9.56982H12.0957C12.4253 9.56982 12.6816 9.31348 12.6816 8.98389C12.6816 8.6543 12.4253 8.39062 12.0957 8.39062H4.50049C4.1709 8.39062 3.91455 8.6543 3.91455 8.98389C3.91455 9.31348 4.1709 9.56982 4.50049 9.56982Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d4d45db6a1f5bf31cd605a052b4c2079.svg";
export { ForwardRef as ReactComponent };